import { useEffect } from "react";
import { useTitle } from "@/core/context/TitleContext";
import { Link } from "react-router-dom";
import { ClipboardDocumentListIcon } from "@heroicons/react/24/outline";
import { ChartColumn, ChartColumnIncreasing, HandCoins } from "lucide-react";

export const OrdersListPage = () => {
  const { setTitle } = useTitle();

  useEffect(() => {
    setTitle("Ordenes de Clientes");
  }, [setTitle]);

  const orderOptions = [
    {
      title: "Renta fija",
      description: "Opera y administra inversiones en instrumentos de deuda.",
      icon: <ChartColumnIncreasing className="w-14 h-14 text-primary-500" />,
      path: "/orders/fixed-income",
    },
    {
      title: "Renta variable",
      description: "Opera y administra inversiones en acciones.",
      icon: <ChartColumn className="w-14 h-14 text-primary-500" />,
      path: "/orders/variable-income",
    },
    {
      title: "Instrumentos",
      description: "Consulta, registra y administra los instrumentos financieros disponibles para negociación.",
      icon: <HandCoins className="w-14 h-14 text-primary-500" />,
      path: "/orders/instruments",
    },
  ];

  return (
    <div className="w-full py-10 px-4 md:px-10">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <ClipboardDocumentListIcon className="w-8 h-8 text-primary-500" />
          <h1 className="text-3xl font-bold">Ordenes de Clientes</h1>
        </div>
        <p className="text-gray-600 dark:text-gray-400">
          Selecciona el tipo de orden que deseas gestionar
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {orderOptions.map(({ title, description, icon, path }) => (
          <Link
            key={path}
            to={path}
            className="flex flex-col items-start bg-white dark:bg-secondary-800 p-6 rounded-lg shadow-neumorph transition hover:shadow-lg hover:-translate-y-1"
          >
            <div className="w-full flex justify-center mb-4">
              {icon}
            </div>
            <h2 className="text-md font-medium mb-1">{title}</h2>
            <p className="text-sm text-gray-600 dark:text-gray-400">{description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};
